module.exports = __webpack_public_path__ + "img/stats_bold.dcfcc21f.png";